export const odluka_o_radu_pod_nadzorom_zastita_na_radu = {
    templateId: 101,
    category: 10,
    templateTitle: "Odluka o radu pod nadzorom - zaštita na radu",
    templateDescription: `<p>Sukladno Zakonu o zaštiti na radu, radnik prije početka rada te u drugim zakonom propisanim razlozima, mora biti osposobljen za rad na siguran način. Ipak, ukoliko poslodavac ne stigne prije početka rada osposobiti radnika za rad na siguran način, Zakon o zaštiti na radu daje mogućnost da najduže u periodu od 60 dana navedeni radnik obavlja poslove uz nadzor radnika koji je osposobljen za rad na siguran način.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Zakonska je obveza poslodavca, prije početka rada, radnika osposobiti za rad na siguran način.</p>
    <p>Osposobljavanje radnika za rad na siguran način obavlja se na temelju procjene rizika, koju je poslodavac dužan izraditi sukladno Zakonu o zaštiti na radu.</p>
    <p>Poslodavac ne smije dozvoliti samostalno obavljanje poslova radniku koji prethodno <strong>nije osposobljen za rad na siguran način.</strong></p>
    <p>Osposobljavanje radnika za rad na siguran način poslodavac je dužan obaviti:</p>
    <li> prije početka rada,</li>
    <li> kod promjena u radnom postupku,</li>
    <li> kod uvođenja nove radne opreme ili njezine promjene,</li>
    <li> kod uvođenja nove tehnologije,</li>
    <li> kod upućivanja radnika na novi posao, odnosno na novo mjesto rada,</li>
    <li> kod utvrđenog oštećenja zdravlja uzrokovanog opasnostima, štetnostima ili naporima na radu.</li>
    <br> 
    <p><strong>Ipak, iz određenih razloga poslodavac ili radnik ponekad ne uspiju na vrijeme obaviti osposobljavanje radnika na siguran način.</strong></p>
    <p><strong>U tom slučaju, poslodavac  je radniku koji nije osposobljen za rad na siguran način dužan osigurati rad pod neposrednim nadzorom radnika osposobljenog za rad na siguran način, ali ne dulje od 60 dana.</strong></p>
    <p>U tu svrhu poslodavac donosi odluku prema primjeru u nastavku.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o zaštiti na radu.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o zaštiti na radu,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: 'donosi sljedeću',
    title: 'ODLUKU O RASPOREĐIVANJU (RADNIKA KOJI NIJE OSPOSOBLJEN ZA RAD NA SIGURAN NAČIN) NA RAD POD NEPOSREDNIM NADZOROM RADNIKA OSPOSOBLJENOG ZA RAD NA SIGURAN NAČIN',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true, 
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'Ovom odlukom osigurava se rad pod neposrednim nadzorom za radnika'},
                        { type: 'input', value: '', required: true, placeholder: "Ime i prezime", },
                        { type: "text", content: "," },
                        { type: 'text', content: 'iz' },
                        { type: 'input', value: '', required: true,placeholder: "Mjesto", },
                        { type: 'text', content: ',' },
                        { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj", },
                        { type: 'text', content: 'OIB:' },
                        { type: "input",  required: true,},
                        {type: 'text', content: ', zaposlenog na radnom mjestu'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: '(u daljnjem tekstu: Radnik pod nadzorom).'},
                    ],
                }],
            value: '',
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'Nadzor Radnika pod nadzorom iz ove Odluke, obavljat će radnik'},
                        { type: 'input', value: '', required: true, placeholder: "Ime i prezime", },
                        { type: "text", content: "," },
                        { type: 'text', content: 'iz' },
                        { type: 'input', value: '', required: true,placeholder: "Mjesto", },
                        { type: 'text', content: ',' },
                        { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj", },
                        { type: 'text', content: 'OIB:' },
                        { type: "input",  required: true,},                    
                        {type: 'text', content: ', zaposlen na radnom mjestu'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: '(u nastavku teksta: Radnik koji obavlja nadzor).'},
                    ],
                }],
            value: '',
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Rad pod neposrednim nadzorom iz ove Odluke trajati će najviše 60 dana od dana početka obavljanja poslova radnika koji nije osposobljen za rad na siguran način (Radnika pod nadzorom) te će se u tom razdoblju obaviti osposobljavanje Radnika pod nadzorom za rad na siguran način.',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Ova Odluka se primjenjuje od dana donošenja.',
                    value: '',
                }],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {
                            type: 'text',
                            content: 'U'
                        },
                        {
                            type: 'input',
                            value: '',
                            placeholder: "Upišite mjesto.",
                            required: true
                        },
                        {
                            type: 'text',
                            content: ', dana'
                        },
                        {
                            type: 'date',
                            value: new Date(),
                            required: true
                        },
                        {
                            type: 'text',
                            content: 'godine.',
                            help: 'Poslodavac mora radnika najmanje petnaest dana prije korištenja godišnjeg odmora obavijestiti o trajanju godišnjeg odmora i razdoblju njegova korištenja.'
                        }
                    ]
                },
            ]
        },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Radniku pod nadzorom \r\n2) Radniku koji obavlja nadzor \r\n3) Kadrovska služba',
                    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                }
            ]
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis radnika pod nadzorom: ______________________________.',
                  
                }
            ]
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: '\r\n\r\n\Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis radnika koji obavlja nadzor: ______________________________.',
                  
                }
            ]
        },
    
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/101_odluka_o_radu_pod_nadzorom_zastita_na_radu.ts